import { AxiosResponse } from "axios"
import { Button, Checkbox } from "components"
import { arraysEqual, deleteAlert } from "pages/Setup/utils"
import { Fragment, useEffect } from "react"
import toast from "react-hot-toast"
import { PiBroomBold } from "react-icons/pi"
import { useApi, useToggle } from "utils"
import { useAllId } from "../utils"

export function DeleteAll(params: {
    deleteList: number[]
    isDeleteAll: boolean
    onSuccess: () => void
}): JSX.Element {
    // Hooks
    const api = useApi()
    const { isActive, setActive } = useToggle(false)

    // Functions
    const getUrl = (): Promise<AxiosResponse<any, any>> => {
        if (params.isDeleteAll) {
            return api.delete("/groupasset/all")
        }

        return api.delete("/groupasset/delete-multiple", { data: params.deleteList })
    }

    if (params.deleteList.length) {
        return (
            <Button
                className="tooltip tooltip-error flex gap-3"
                color="ghost"
                loading={isActive ? "true" : undefined}
                onClick={() => {
                    deleteAlert(params.isDeleteAll).then(() => {
                        setActive(true)

                        toast.promise(
                            getUrl(),
                            {
                                loading: "Loading...",
                                success: (res) => res.data.message,
                                error: (err) => err.response.data?.message ?? err.response.message
                            }
                        ).then(() => {
                            params.onSuccess()
                        }).catch(() => {
                        }).finally(() => {
                            setActive(false)
                        })
                    }).catch(() => { })
                }}
            >
                {params.isDeleteAll ? "DELETE ALL DATA" : "DELETE SELECTED DATA"} <PiBroomBold className="w-[20px] h-[20px]" />
            </Button>
        )
    }

    return <Fragment />
}


export function SelectAll(params: {
    deleteList: number[]
    isDeleteAll: boolean
    toggle: (value: number[]) => void
    toggleDeleteAll: (value: boolean) => void
}): JSX.Element {
    // Hooks
    const { data } = useAllId()

    useEffect(() => {
        if (!params.deleteList.length) {
            return params.toggleDeleteAll(false)
        }

        return params.toggleDeleteAll(arraysEqual(params.deleteList, data))

        // eslint-disable-next-line
    }, [params.deleteList])

    return (
        <th>
            {data.length ? (
                <Checkbox
                    value={params.isDeleteAll}
                    onClick={() => {
                        if (!arraysEqual(params.deleteList, data)) {
                            return params.toggle(data)
                        }

                        return params.toggle([])
                    }}
                />
            ) : (
                <Fragment />
            )}
        </th>
    )
}